import {
    Box,
    FormControl,
    FormLabel,
    Stack,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { Field } from 'formik';
import { useState, useMemo } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    dropDownFormStyle,
    formSelectStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
    textBoxStyling,
} from 'components/forms/new/formStyles';

const TRSNodeClusterField = ({
    errors,
    values,
    touched,
    clusters = [],
    darkMode,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    const selectedCluster = useMemo(() => {
        if (!clusters.length || !values?.clusterID) return null;
        return clusters.find((c) => c.id === values.clusterID) || null;
    }, [clusters, values?.clusterID]);

    const baseStyles = dropDownFormStyle(darkMode);
    const filterOption = (option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase());

    return (
        <FormControl
            isRequired
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.clusterID && touched.clusterID}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        TRS Cluster
                    </FormLabel>
                    <Text
                        sx={{
                            ...descriptionStyling,
                            color: darkMode ? 'gray.100' : '#757575',
                        }}
                        maxW={250}>
                        Choose the TRS Cluster for this node
                    </Text>
                </Box>
                <Field name="clusterID">
                    {({ field, form: { setFieldValue, setTouched } }) => (
                        <Box
                            flex="1"
                            sx={{
                                paddingTop: '15px',
                                ...formSelectStyles,
                            }}>
                            <VStack width="100%" alignItems="normal">
                                <Select
                                    {...field}
                                    tabSelectsValue
                                    openMenuOnFocus
                                    placeholder="Select cluster"
                                    sx={{
                                        ...textBoxStyling,
                                        color: darkMode
                                            ? 'dark.textDark'
                                            : null,
                                        background: darkMode
                                            ? 'dark.bgDark'
                                            : null,
                                        borderColor: darkMode
                                            ? 'dark.tcap-borderGray'
                                            : null,
                                    }}
                                    value={selectedCluster}
                                    options={clusters}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    filterOption={filterOption}
                                    chakraStyles={baseStyles}
                                    onChange={(selectedOption) => {
                                        const clusterId =
                                            selectedOption?.id || '';
                                        setFieldValue('clusterID', clusterId);
                                    }}
                                    selectedOptionColor="brand"
                                    onBlur={() => {
                                        setTouched({
                                            ...touched,
                                            clusterID: true,
                                        });
                                    }}
                                />
                            </VStack>
                        </Box>
                    )}
                </Field>

                {isHovered && (
                    <FieldToolTip
                        label="Select the TRS Cluster that this node will belong to"
                        ariaLabel="node-cluster-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError
                error={errors?.clusterID}
                touched={touched?.clusterID}
            />
        </FormControl>
    );
};

export default TRSNodeClusterField;
